<mat-toolbar fxLayout="row" color="primary" id="mifosx-toolbar">

  <span fxFlex="auto"></span>
  <mifosx-language-selector class="ml-1 language" fxHide.lt-md></mifosx-language-selector>

  <mifosx-theme-picker fxHide.lt-md></mifosx-theme-picker>

  <mifosx-notifications-tray fxHide.lt-md></mifosx-notifications-tray>

  <button mat-icon-button class="ml-1 img-button" [matMenuTriggerFor]="applicationMenu">
    <mat-icon>
      <fa-icon icon="user" size="sm"></fa-icon>
    </mat-icon>
  </button>

</mat-toolbar>

<!-- Application User Help Menu -->
<mat-menu #applicationMenu="matMenu" [overlapTrigger]="false">
  <button mat-menu-item [routerLink]="['/profile']">
    <mat-icon>
      <fa-icon icon="user" size="sm"></fa-icon>
    </mat-icon>
    <span>Perfil</span>
  </button>
  <button mat-menu-item (click)="logout()" id="logout">
    <mat-icon>
      <fa-icon icon="sign-out-alt" size="sm"></fa-icon>
    </mat-icon>
    <span>Cerrar sesión</span>
  </button>
</mat-menu>
